export default __webpack_public_path__ + "static/media/wholesale-group.274e53c2.svg";